import { Separator } from 'components/ui/separator';

export const FormsSeparator = () => (
  <Separator className="my-3 bg-base-border ml-2 w-[290px]" />
);
